<template>
  <v-card color="transparent" flat>
    <v-list-item>
      <v-list-item-avatar style="transform: scaleX(-1)">
        <SvgIcon icon="cp-fish-1" fill="#0087af" height="75px" />
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="title font-weight-bold primary--text"
          >Registra tus avistamientos</v-list-item-title
        >
        <v-list-item-subtitle
          >* Opcional, lo puedes completar después</v-list-item-subtitle
        >
      </v-list-item-content>
    </v-list-item>

    <OrganismSelector v-on:select="addItem"></OrganismSelector>

    <v-divider class="mt-8 mb-8 primary"></v-divider>

    <v-row v-if="listFiltered && listFiltered.length > 0">
      <v-col
        cols="12"
        sm="6"
        v-for="(item, index) in listFiltered"
        :key="index"
      >
        <OccurrenceItemCard
          :item.sync="item"
          v-on:remove="removeItem"
          editable="true"
        ></OccurrenceItemCard>
      </v-col>
    </v-row>

    <v-card
      v-else
      class="mt-8 d-flex align-center justify-center"
      style="height: 200px"
      flat
      color="transparent"
    >
      <span class="body-2 font-weight-light text-center"
        >No has agregado especies a tu listado</span
      >
    </v-card>

    <v-snackbar v-model="snackError.show" color="error">{{
      snackError.msg
    }}</v-snackbar>
  </v-card>
</template>

<script>
import OrganismSelector from "../Organism/OrganismSelector";
import OccurrenceItemCard from "./OccurrenceItemCard";
import SvgIcon from "@/components/SvgIcon";
export default {
  components: {
    OrganismSelector,
    OccurrenceItemCard,
    SvgIcon
  },
  props: {
    list: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data: () => ({
    searchText: "",
    snackError: {
      show: false,
      msg: ""
    }
  }),
  computed: {
    listFiltered() {
      return (this.list || []).filter(({ deleted }) => !(deleted == true));
    }
  },
  methods: {
    addItem(item) {
      if (
        this.list.some(
          ({ organism, deleted }) => organism.id == item.id && !deleted
        )
      ) {
        return (this.snackError = {
          show: true,
          msg: "Especie ya está agregada en tu lista"
        });
      }
      this.list.push({
        organism: item
      });
      this.$emit("update:list", this.list);
    },
    removeItem(item) {
      let { id, organism } = item;
      if (id) {
        this.list = this.list.map(item =>
          item.id == id ? { ...item, deleted: true } : item
        );
      } else {
        let { id: idOrganism } = organism;
        this.list = this.list.filter(
          ({ organism }) => organism.id != idOrganism
        );
      }
      this.$emit("update:list", this.list);
    }
  }
};
</script>

<style></style>
